<template>
  <component :is="tag" class="more-help">
    <div class="section-inner">
      <h2 v-if="blok.title" class="size-xl title align-center margin-s-bottom">{{ blok.title }}</h2>
      <div v-if="cardsLength < 4" class="cards cards-desktop-only">
        <StoryblokComponent
          v-for="card in blok.cards"
          :key="card._uid"
          :blok="card"
          :level="3"
          class="card"
          :size-hint="44"
        />
      </div>
      <div
        :class="`carousel-container carousel-full-width ${cardsLength > 3 ? 'carousel-always' : 'carousel-mobile-only'}`"
      >
        <GenericCarousel
          v-if="blok.cards?.length > 1"
          :items="blok.cards"
          :slides-per-view="'auto'"
          :space-between="14"
          class="carousel-navigation-bottom"
          :child-level="3"
          child-classes="card"
          :size-hint="44"
        />
      </div>
    </div>
  </component>
</template>

<script setup>
const props = defineProps({
  blok: {
    type: Object,
    required: true,
  },
  tag: {
    type: String,
    required: false,
    default: "div",
  },
});

const { blok } = toRefs(props); // eslint-disable-line

const cardsLength = blok.value.cards?.length;
</script>

<style lang="scss">
.background.alternate .more-help .card {
  @include pair-7;
}
</style>

<style lang="scss" scoped>
.more-help {
  .cards {
    display: flex;
    align-items: center;
    gap: 0.83rem;
    &-desktop-only {
      display: none;
      @include for-tablet-landscape-up {
        display: flex;
      }
    }
  }

  .carousel-mobile-only {
    display: block;
    @include for-tablet-landscape-up {
      display: none;
    }
  }

  .carousel-always {
    display: block;
  }

  :deep(.card.is-special) {
    @include pair-6;
  }
}
</style>
